import { Component, OnInit } from '@angular/core';
import { NavbarService } from '../../../../../shared/navbar/navbar.service';
import { MenuService } from '../../../../../shared/menu/menu.service';
import { LoaderService } from '../../../../../shared/loader/loader.service';
import { AlunosService } from '../../alunos/alunos.service';
import { ToastService } from '../../../../../shared/toast/toast.service';
import { StorageServiceService } from '../../../../../shared/storage/storage-service.service';

@Component({
  selector: 'app-documentos',
  standalone: true,
  imports: [],
  templateUrl: './documentos.component.html',
  styleUrl: './documentos.component.scss',
})
export class DocumentosComponent implements OnInit {

  documentIdAluno: string = '';
  idAluno!: number;

  constructor(
    private readonly loaderService: LoaderService,
    private readonly alunosService: AlunosService,
    private readonly toast: ToastService,
    private readonly storageService: StorageServiceService
  ) {}

  ngOnInit(): void {
    this.alunosService.alunoSelecionado.subscribe((value) => {
      if (value === null) {
        this.documentIdAluno = this.storageService.obterAluno()?.documentId as string;
        this.idAluno = this.storageService.obterAluno()?.id as number;
      } else {
        this.documentIdAluno = value?.documentId;
        this.idAluno = value?.id;
      }
    });
    this.buscarAlunoPorId();
  }

  buscarAlunoPorId() {
    this.loaderService
      .executeWithLoader(
        this.alunosService.buscarAlunoPorIdPopulateFotos(
          this.documentIdAluno,
        ),
      )
      .subscribe({
        next: (value: any) => {
          console.log(value.data);
        },
        error: (error) => {
          this.toast.error('Erro interno ao buscar Aluno !');
        },
      });
  }
}
